var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CalendarPage"},[_c('Intro'),_c('Calendars')],1)}
var staticRenderFns = []

export { render, staticRenderFns }